import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a61a204 from 'nuxt_plugin_plugin_1a61a204' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_31365a50 from 'nuxt_plugin_sentryserver_31365a50' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_fca93d60 from 'nuxt_plugin_sentryclient_fca93d60' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_image_42f8640f from 'nuxt_plugin_image_42f8640f' // Source: ./image.js (mode: 'all')
import nuxt_plugin_distplugin354b27cc_1c6ac13c from 'nuxt_plugin_distplugin354b27cc_1c6ac13c' // Source: ./dist.plugin.354b27cc.js (mode: 'all')
import nuxt_plugin_toast_2421b3c3 from 'nuxt_plugin_toast_2421b3c3' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_pluginutils_ad54dcb2 from 'nuxt_plugin_pluginutils_ad54dcb2' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_60385132 from 'nuxt_plugin_pluginrouting_60385132' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6b891106 from 'nuxt_plugin_pluginmain_6b891106' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_57f16714 from 'nuxt_plugin_axios_57f16714' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_router_5a88071b from 'nuxt_plugin_router_5a88071b' // Source: ./router.js (mode: 'all')
import nuxt_plugin_deviceplugin_098aaa9f from 'nuxt_plugin_deviceplugin_098aaa9f' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_pluginserver_6bc0aea8 from 'nuxt_plugin_pluginserver_6bc0aea8' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_06073d20 from 'nuxt_plugin_pluginclient_06073d20' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_eventbus_5e09fed2 from 'nuxt_plugin_eventbus_5e09fed2' // Source: ../plugins/event-bus.ts (mode: 'client')
import nuxt_plugin_isclient_e48a6014 from 'nuxt_plugin_isclient_e48a6014' // Source: ../plugins/is-client.ts (mode: 'all')
import nuxt_plugin_i18nAndCache_7f840ca6 from 'nuxt_plugin_i18nAndCache_7f840ca6' // Source: ../plugins/i18nAndCache.ts (mode: 'all')
import nuxt_plugin_clickaway_c51451d0 from 'nuxt_plugin_clickaway_c51451d0' // Source: ../plugins/clickaway.js (mode: 'client')
import nuxt_plugin_vuejsmodal_0719e4a0 from 'nuxt_plugin_vuejsmodal_0719e4a0' // Source: ../plugins/vue-js-modal.js (mode: 'all')
import nuxt_plugin_customdomains_721a14fa from 'nuxt_plugin_customdomains_721a14fa' // Source: ../plugins/custom-domains.ts (mode: 'all')
import nuxt_plugin_vueresize_16c47ac5 from 'nuxt_plugin_vueresize_16c47ac5' // Source: ../plugins/vue-resize.js (mode: 'all')
import nuxt_plugin_axiosext_425fc80c from 'nuxt_plugin_axiosext_425fc80c' // Source: ../plugins/axios-ext.ts (mode: 'all')
import nuxt_plugin_apiclient_5a93e002 from 'nuxt_plugin_apiclient_5a93e002' // Source: ../plugins/apiclient.ts (mode: 'all')
import nuxt_plugin_globalerrorhandler_8a10008a from 'nuxt_plugin_globalerrorhandler_8a10008a' // Source: ../plugins/global-error-handler.ts (mode: 'all')
import nuxt_plugin_mountstore_30a18177 from 'nuxt_plugin_mountstore_30a18177' // Source: ../plugins/mount-store.ts (mode: 'all')
import nuxt_plugin_chromecastclient_1a9ef238 from 'nuxt_plugin_chromecastclient_1a9ef238' // Source: ../plugins/chromecast.client.ts (mode: 'client')
import nuxt_plugin_auth_405f0f9c from 'nuxt_plugin_auth_405f0f9c' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_users_38061e08 from 'nuxt_plugin_users_38061e08' // Source: ../plugins/users.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a61a204 === 'function') {
    await nuxt_plugin_plugin_1a61a204(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_31365a50 === 'function') {
    await nuxt_plugin_sentryserver_31365a50(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_fca93d60 === 'function') {
    await nuxt_plugin_sentryclient_fca93d60(app.context, inject)
  }

  if (typeof nuxt_plugin_image_42f8640f === 'function') {
    await nuxt_plugin_image_42f8640f(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin354b27cc_1c6ac13c === 'function') {
    await nuxt_plugin_distplugin354b27cc_1c6ac13c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_2421b3c3 === 'function') {
    await nuxt_plugin_toast_2421b3c3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ad54dcb2 === 'function') {
    await nuxt_plugin_pluginutils_ad54dcb2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_60385132 === 'function') {
    await nuxt_plugin_pluginrouting_60385132(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6b891106 === 'function') {
    await nuxt_plugin_pluginmain_6b891106(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_57f16714 === 'function') {
    await nuxt_plugin_axios_57f16714(app.context, inject)
  }

  if (typeof nuxt_plugin_router_5a88071b === 'function') {
    await nuxt_plugin_router_5a88071b(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_098aaa9f === 'function') {
    await nuxt_plugin_deviceplugin_098aaa9f(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_6bc0aea8 === 'function') {
    await nuxt_plugin_pluginserver_6bc0aea8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_06073d20 === 'function') {
    await nuxt_plugin_pluginclient_06073d20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventbus_5e09fed2 === 'function') {
    await nuxt_plugin_eventbus_5e09fed2(app.context, inject)
  }

  if (typeof nuxt_plugin_isclient_e48a6014 === 'function') {
    await nuxt_plugin_isclient_e48a6014(app.context, inject)
  }

  if (typeof nuxt_plugin_i18nAndCache_7f840ca6 === 'function') {
    await nuxt_plugin_i18nAndCache_7f840ca6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickaway_c51451d0 === 'function') {
    await nuxt_plugin_clickaway_c51451d0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_0719e4a0 === 'function') {
    await nuxt_plugin_vuejsmodal_0719e4a0(app.context, inject)
  }

  if (typeof nuxt_plugin_customdomains_721a14fa === 'function') {
    await nuxt_plugin_customdomains_721a14fa(app.context, inject)
  }

  if (typeof nuxt_plugin_vueresize_16c47ac5 === 'function') {
    await nuxt_plugin_vueresize_16c47ac5(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosext_425fc80c === 'function') {
    await nuxt_plugin_axiosext_425fc80c(app.context, inject)
  }

  if (typeof nuxt_plugin_apiclient_5a93e002 === 'function') {
    await nuxt_plugin_apiclient_5a93e002(app.context, inject)
  }

  if (typeof nuxt_plugin_globalerrorhandler_8a10008a === 'function') {
    await nuxt_plugin_globalerrorhandler_8a10008a(app.context, inject)
  }

  if (typeof nuxt_plugin_mountstore_30a18177 === 'function') {
    await nuxt_plugin_mountstore_30a18177(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chromecastclient_1a9ef238 === 'function') {
    await nuxt_plugin_chromecastclient_1a9ef238(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_405f0f9c === 'function') {
    await nuxt_plugin_auth_405f0f9c(app.context, inject)
  }

  if (typeof nuxt_plugin_users_38061e08 === 'function') {
    await nuxt_plugin_users_38061e08(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
